import "./pipeline.css";
import { useContext, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import PipelineCategoryView from "../../components/pipelineCategoryView/pipelineCategoryView";
import { AuthContext } from "../../context/AuthContext/AuthContext";

function Pipeline() {
  const [pipelineData, setPipelineData] = useState();
  const [pipelineView, setPipelineView] = useState("intake");
  const [filteredValues, setFilteredValues] = useState({ searchValue: null, assignedToValue: null, typeFilter: null });
  const [clioUserList, setClioUserList] = useState(null);
  const [matterStatusList, setMatterStatusList] = useState(null);
  const { user } = useContext(AuthContext);

  const onHandleEvent = (event, setFunction) => {
    const { name, value } = event.target;
    setFunction((previousState) => ({ ...previousState, [name]: value }));
  };

  const handleReset = () => {
    setFilteredValues({ searchValue: "", assignedToValue: "", typeFilter: "" });
  };

  return (
    <div className="page-content pipeline-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-header">
              <div className="page-header-left">
                <button
                  type="button"
                  className={pipelineView === "intake" ? "btn active" : "btn"}
                  onClick={() => {
                    setPipelineView("intake");
                  }}
                >
                  Intake
                </button>
                <button
                  type="button"
                  className={pipelineView === "hired" ? "btn active" : "btn"}
                  onClick={() => {
                    setPipelineView("hired");
                  }}
                >
                  Hired
                </button>
                <button
                  type="button"
                  className={pipelineView === "declined" ? "btn active" : "btn"}
                  onClick={() => {
                    setPipelineView("declined");
                  }}
                >
                  Not Hired
                </button>
              </div>
              <div className="page-header-right page-title-box-content">
                <button type="button" className="page-title-btn refresh-button" title="Reset" onClick={handleReset}>
                  <i className="ri-refresh-line"></i>
                </button>
                <div className="app-search">
                  <Dropdown
                    name="typeFilter"
                    value={filteredValues.typeFilter}
                    onChange={(e) => onHandleEvent(e, setFilteredValues)}
                    options={matterStatusList?.type}
                    filter
                    filterDelay={400}
                    optionValue="type"
                    optionLabel="type"
                    appendTo="self"
                    placeholder="Filter by Type"
                  />
                </div>
                {user?.role === 1 ? (
                  <div className="app-search">
                    <Dropdown
                      name="assignedToValue"
                      value={filteredValues.assignedToValue}
                      onChange={(e) => onHandleEvent(e, setFilteredValues)}
                      options={clioUserList}
                      optionValue="id"
                      optionLabel="name"
                      appendTo="self"
                      placeholder="Filter by assignee"
                    />
                  </div>
                ) : (
                  ""
                )}
                <form className="app-search">
                  <div className="position-relative">
                    <input
                      type="search"
                      className="form-control border-0"
                      placeholder="Search..."
                      autoComplete="off"
                      value={filteredValues.searchValue || ""}
                      onChange={(e) => onHandleEvent(e, setFilteredValues)}
                      name="searchValue"
                    />
                    <i className="ri-search-line search-widget-icon"></i>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <PipelineCategoryView
          user={user}
          pipelineData={pipelineData}
          setPipelineData={setPipelineData}
          category={pipelineView}
          filteredValues={filteredValues}
          clioUserList={clioUserList}
          setClioUserList={setClioUserList}
          matterStatusList={matterStatusList}
          setMatterStatusList={setMatterStatusList}
        />
      </div>
    </div>
  );
}

export default Pipeline;
